var QUILL_INSTANCE = null;
var COLOR_PICKER_INSTANCE = null;
var QUILL_SELECT_TEXT_FUNC = null;
var QUILL_UPDATE_VALUE_FUNC = null;
var CURRENT_QUILL = null;
var QUILL_CLICK_LISTENER = null;
var QUILL_IFRAME_LISTENER = null;
/* Directives */

_BannerFlowApp.directive("valueUpdated", [
    "$timeout",
    function ($timeout) {
        return {
            restrict: "A",
            require: "ngModel",

            controller: function () {},
            link: function (scope, element, attrs, ngModel) {
                scope.$watch("model", function () {
                    if (scope.callback) scope.callback();
                });
            }
        };
    }
]);

_BannerFlowApp.directive("quill", [
    "$timeout",
    function ($timeout) {
        return {
            restrict: "A",
            require: "ngModel",
            replace: true,
            scope: {
                callback: "&valueUpdated",
                touched: "&?"
            },
            templateUrl: "/legacy-app/js/directives/quill.html",
            link: function (scope, element, attrs, ngModel) {
                scope.$watch(
                    function () {
                        return ngModel.$modelValue;
                    },
                    function (newVal, oldVal) {
                        scope.callback();
                    },
                    true
                );

                $(".quill-wrapper").addClass("collapsed");

                $("#text-editor", $(element)).html(ngModel.$viewValue);

                ngModel.$render = function () {
                    if (QUILL_INSTANCE && angular.isDefined(QUILL_INSTANCE)) {
                        //$timeout(function () {
                        QUILL_INSTANCE.setHTML(ngModel.$viewValue || "");
                        //});
                    } else {
                        //$timeout(function () {
                        $("#text-editor", $(element)).html(ngModel.$viewValue);
                        //});
                    }
                };

                //ngModel.$render();

                var initQuill = function (startSelection) {
                    $(element).removeClass("collapsed");
                    CURRENT_QUILL = $(element).attr("id");
                    var currentSelection = null;

                    QUILL_SELECT_TEXT_FUNC = function (delta, source) {
                        if (!QUILL_INSTANCE) return;

                        if (QUILL_INSTANCE.getSelection())
                            currentSelection = QUILL_INSTANCE.getSelection();
                        if (QUILL_INSTANCE.getSelection()) {
                            var contents = QUILL_INSTANCE.getContents(
                                currentSelection.start,
                                currentSelection.end
                            );
                            if (currentSelection.isCollapsed())
                                contents = QUILL_INSTANCE.getContents(
                                    Math.max(0, currentSelection.start - 1),
                                    currentSelection.end
                                );
                            var color = "#333";
                            if (
                                contents &&
                                contents.ops &&
                                contents.ops.length > 0 &&
                                contents.ops[0].attributes &&
                                contents.ops[0].attributes.color
                            ) {
                                color = contents.ops[0].attributes.color;
                            }

                            $("#text-toolbar .color-input", $(element)).val(color);
                            $("#text-toolbar .color-input", $(element)).css("color", color);
                            $("#text-toolbar .color-input", $(element)).css("background-color", color);
                        }
                    };

                    QUILL_UPDATE_VALUE_FUNC = function (delta, source) {
                        var self = this;
                        scope.$apply(function () {
                            if (scope.touched) scope.touched();

                            var val = self.getHTML();

                            if (
                                val &&
                                val.indexOf("<div", 1) == -1 &&
                                val.indexOf("<i>") == -1 &&
                                val.indexOf("<u>") == -1 &&
                                val.indexOf("<s>") == -1 &&
                                val.indexOf("<b>") == -1 &&
                                val.indexOf("<span") == -1
                            ) {
                                val = val.replace(/(<([^>]+)>)/gi, "");
                            }

                            ngModel.$setViewValue(val);
                        });
                    };

                    var options = {
                        modules: {
                            toolbar: { container: "#" + CURRENT_QUILL + " #text-toolbar" },
                            "image-tooltip": true,
                            "link-tooltip": true
                        },
                        styles: {
                            ".image-tooltip-container": {
                                display: "none"
                            }
                        },
                        theme: "snow",
                        formats: ["bold", "italic", "color", "underline", "strike"]
                    };
                    var extraOptions = attrs.quill ? scope.$eval(attrs.quill) : {};

                    angular.extend(options, extraOptions);

                    //$timeout(function () {

                    QUILL_INSTANCE = new Quill(element.children("#text-editor")[0], options);

                    QUILL_INSTANCE.on("text-change", QUILL_UPDATE_VALUE_FUNC);

                    QUILL_INSTANCE.on("selection-change", QUILL_SELECT_TEXT_FUNC);

                    if (QUILL_INSTANCE) {
                        if (startSelection) {
                            if (startSelection.start > startSelection.end) {
                                var start = startSelection.start;
                                startSelection.start = startSelection.end;
                                startSelection.end = start;
                            }
                            QUILL_INSTANCE.setSelection(startSelection.start, startSelection.end);
                        } else {
                            QUILL_INSTANCE.setSelection(
                                QUILL_INSTANCE.getLength(),
                                QUILL_INSTANCE.getLength()
                            );
                        }

                        var $editorElement = $(QUILL_INSTANCE.editor.root);
                        var $editorRoot = $(QUILL_INSTANCE.root);

                        $editorElement.attr({
                            autocomplete: "off",
                            autocorrect: "off",
                            autocapitalize: "off",
                            spellcheck: "false"
                        });
                    }

                    COLOR_PICKER_INSTANCE = $(".color-input", $(element)).colorpicker({
                        format: "rgba"
                    });

                    $(".color-input", $(element)).on("click", function (e) {
                        COLOR_PICKER_INSTANCE.colorpicker("show");
                    });

                    COLOR_PICKER_INSTANCE.on("changeColor", function (e) {
                        QUILL_INSTANCE.focus();

                        var rgb = e.color.toRGB();

                        //Hack to get quill to not freak out when color is full black
                        if (rgb.r + rgb.g + rgb.b === 0 && rgb.a >= 0.99) {
                            rgb.a = 0.99;
                        }
                        //Reset alpha to 1
                        else if (rgb.a >= 0.99) {
                            rgb.a = 1;
                        }
                        color = "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")";

                        if (currentSelection) {
                            if (currentSelection.isCollapsed()) {
                                QUILL_INSTANCE.prepareFormat("color", color);
                            } else {
                                QUILL_INSTANCE.formatText(
                                    currentSelection.start,
                                    currentSelection.end,
                                    "color",
                                    color
                                );
                            }
                        }

                        $(".color-input", $(element)).val(color);
                        $(".color-input", $(element)).css("color", color);
                        $(".color-input", $(element)).css("background-color", color);
                    });

                    QUILL_CLICK_LISTENER = $(".ql-unformat", $(element)).click(function () {
                        if (currentSelection) {
                            QUILL_INSTANCE.focus();
                            QUILL_INSTANCE.prepareFormat("color", false);
                            QUILL_INSTANCE.prepareFormat("bold", false);
                            QUILL_INSTANCE.prepareFormat("italic", false);
                            QUILL_INSTANCE.prepareFormat("underline", false);
                            QUILL_INSTANCE.prepareFormat("strike", false);
                            if (!currentSelection.isCollapsed()) {
                                for (var i = 0; i < 10; i++) {
                                    try {
                                        QUILL_INSTANCE.formatText(
                                            currentSelection.start,
                                            currentSelection.end,
                                            "bold",
                                            false
                                        );
                                        QUILL_INSTANCE.formatText(
                                            currentSelection.start,
                                            currentSelection.end,
                                            "italic",
                                            false
                                        );
                                        QUILL_INSTANCE.formatText(
                                            currentSelection.start,
                                            currentSelection.end,
                                            "underline",
                                            false
                                        );
                                        QUILL_INSTANCE.formatText(
                                            currentSelection.start,
                                            currentSelection.end,
                                            "strike",
                                            false
                                        );
                                        QUILL_INSTANCE.formatText(
                                            currentSelection.start,
                                            currentSelection.end,
                                            "color",
                                            false
                                        );
                                    } catch (e) {}
                                }
                                QUILL_INSTANCE.setSelection(
                                    currentSelection.start,
                                    currentSelection.end
                                );
                            }
                        }
                    });
                    //});
                };

                var cleanup = function () {
                    if (QUILL_IFRAME_LISTENER) {
                        QUILL_IFRAME_LISTENER.off("mousedown");
                    }

                    if (COLOR_PICKER_INSTANCE) {
                        COLOR_PICKER_INSTANCE.off("changeColor");
                        COLOR_PICKER_INSTANCE.off("click");
                        COLOR_PICKER_INSTANCE = null;
                        // delete COLOR_PICKER_INSTANCE;
                    }

                    if (QUILL_INSTANCE) {
                        QUILL_INSTANCE.off("text-change", QUILL_UPDATE_VALUE_FUNC);
                        QUILL_INSTANCE.off("selection-change", QUILL_UPDATE_VALUE_FUNC);
                    }

                    if (QUILL_CLICK_LISTENER) QUILL_CLICK_LISTENER.off("click");

                    /*if (QUILL_INSTANCE) {
                      $(".quill-wrapper").each(function () {
                          $("#text-editor", $(this)).removeClass();
                          if ($(this).attr('id') === CURRENT_QUILL) {
                              $("#text-editor", $(this)).html(QUILL_INSTANCE.getHTML());
                          }
                      });
                  }*/

                    for (var i = 0; i < Quill.editors.length; i++) {
                        $("#{0}".format(Quill.editors[i].id)).remove();
                        Quill.editors[i].destroy();
                    }

                    Quill.editors = new Array();

                    $(window).off("mousedown");

                    QUILL_INSTANCE = null;
                    CURRENT_QUILL = "";
                };

                $(element).on("mouseup", function (e) {
                    var selection = null;

                    var sel = window.getSelection();
                    var offset = null;

                    if (sel.type === "Range" || !sel.isCollapsed) {
                        offset = {
                            start: sel.anchorOffset,
                            end: sel.focusOffset
                        };
                    } else {
                        offset = {
                            start: sel.focusOffset,
                            end: sel.focusOffset
                        };
                    }

                    selection = {
                        start: offset.start,
                        end: offset.end
                    };

                    if (CURRENT_QUILL != $(e.currentTarget).attr("id")) {
                        $(".quill-wrapper").addClass("collapsed");

                        if (QUILL_INSTANCE) {
                            cleanup();

                            initQuill(selection);
                        } else {
                            initQuill(selection);
                        }

                        $(window).on("mousedown", function (e) {
                            if (
                                $(e.target).hasClass("btn-success") ||
                                $(e.target).hasClass("quill-editor") ||
                                $(e.target).hasClass("colorpicker") ||
                                $(e.target).parents(".quill-editor").size() ||
                                $(e.target).parents(".colorpicker").size()
                            ) {
                            } else {
                                cleanup();
                                $(".quill-wrapper").addClass("collapsed");
                            }
                            return true;
                        });
                    } else {
                        return true;
                    }
                });

                scope.$on("$destroy", function () {
                    cleanup();
                });
            }
        };
    }
]);
